'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:modal');
}

var _invoke = require('../invoke');

/**
 * 打开 modal 弹窗
 *
 * 1. 与 `hbnb.webivew.dismiss` 配合使用
 * 2. `modal` 弹窗内部不能继续调用 `modal` 弹窗，可以调用 `open`
 * 3. `dimiss` 时会关闭弹窗，且 modal 的操作不会纪录到后退路径中
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof webview
 * @static
 * @name modal
 * @param {String} url 页面地址
 * @return {Undefined}
 * @example
 *  hbnb.webview.modal('http://i.meituan.com');
 */
module.exports = function(url) {
    if (process.env.NODE_ENV !== 'production') {
        debug('url is %s', url);
    }

    _invoke('webview', 'modal', {
        url: url
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/webview/modal.js
// module id = 662
// module chunks = 0